import { render, staticRenderFns } from "./VolumesBarChart.vue?vue&type=template&id=20c5a5f4&"
import script from "./VolumesBarChart.vue?vue&type=script&lang=ts&"
export * from "./VolumesBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./VolumesBarChart.vue?vue&type=style&index=0&id=20c5a5f4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports